import React from 'react';
import './pincodeTable.scss';
import NoDataFound from '../../component/noDataComponent/NoDataFound';

const renderSkeletonRows = (count = 5) =>
  Array.from({ length: count }).map((_, i) => (
    <tr key={`sk-${i}`} className="skeleton-row">
      <td><span className="skeleton text w-10" /></td>
      <td><span className="skeleton text w-28" /></td>
      <td><span className="skeleton text w-32" /></td>
      <td><span className="skeleton text w-32" /></td>
      <td><span className="skeleton text w-32" /></td>
      <td><span className="skeleton text w-28" /></td>
      <td><span className="skeleton text w-24" /></td>
    </tr>
  ));

const PincodeTable = ({
  data,
  totalPages,
  currentPage,
  setCurrentPage,
  loading = false,
  totalCount = 0,
  pageSize = 10,
  pageWindow = []
}) => {
  // Calculate result info
  const startIndex = totalCount > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endIndex = Math.min(currentPage * pageSize, totalCount);

  return (
    <div className="pincode-table-wrapper">
      <div className="table-container">
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                <th>SNo</th>
                <th>Pincode</th>
                <th>State</th>
                <th>City</th>
                <th>District</th>
                <th>APS Code</th>
                <th>Country</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                renderSkeletonRows(5)
              ) : data.length === 0 ? (
                <tr>
                  <td colSpan="7" style={{ textAlign: 'center', padding: '2rem' }}>
                    <NoDataFound />
                  </td>
                </tr>
              ) : (
                data.map((row, index) => (
                  <tr key={row.id || index}>
                    <td className="sno-cell">{(currentPage - 1) * pageSize + index + 1}</td>
                    <td className="pincode-cell">{row.pincode || 'N/A'}</td>
                    <td className="state-cell">{row.state || 'N/A'}</td>
                    <td className="city-cell">{row.city || 'N/A'}</td>
                    <td className="district-cell">{row.district || 'N/A'}</td>
                    <td className="aps-code-cell">{row.aps_code || 'N/A'}</td>
                    <td className="country-cell">{row.country || 'N/A'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="table-footer">
          {loading ? (
            <div className="footer-skeleton">
              <span className="skeleton text w-40" />
              <div className="pagination">
                <span className="skeleton pill w-16" />
                <span className="skeleton pill w-8" />
                <span className="skeleton pill w-8" />
                <span className="skeleton pill w-8" />
                <span className="skeleton pill w-16" />
              </div>
            </div>
          ) : (
            <>
              <div className="results-info">
                {totalCount > 0 ? `Showing ${startIndex} to ${endIndex} of ${totalCount} results` : 'No results'}
              </div>
              <div className="pagination">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                  className="prev-btn"
                >
                  Previous
                </button>
                {pageWindow.map((p, idx) =>
                  typeof p === "string" ? (
                    <button key={p + idx} className="page-btn ellipsis-btn" disabled>
                      …
                    </button>
                  ) : (
                    <button
                      key={p}
                      onClick={() => setCurrentPage(p)}
                      className={`page-btn ${currentPage === p ? 'active' : ''}`}
                    >
                      {p}
                    </button>
                  )
                )}
                <button
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                  className="next-btn"
                >
                  Next
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PincodeTable;
